import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCenterPivotTurnArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 320,
	height: 128,
	viewBox: "0 -8 320 144",
	xmlSpace: "preserve",
	style: { zoom: 1 },
	...props,
	children: /* @__PURE__ */ _jsx("polygon", {
		points: "       0,64       64,0 112,0       72,40 248,40       208,0 256,0        320,64        256,128 208,128        248,88 72,88       112,128 64,128     ",
		stroke: "#000000",
		strokeWidth: "16px"
	})
});
export default SvgCenterPivotTurnArrow;
